define('plugin/paid-attributes/step/PaidAttributesStep',['require','lib/controller/booking/BaseStep','plugin/paid-attributes/view/step/AttributeLayout','plugin/paid-attributes/view/step/AttributeListView','plugin/paid-attributes/view/step/AttributeTotalsView','view/controller/booking/datetime/SidebarView'],function (require) {

	var BaseStep = require('lib/controller/booking/BaseStep');
    var AttributeLayout = require('plugin/paid-attributes/view/step/AttributeLayout');
    var AttributeListView = require('plugin/paid-attributes/view/step/AttributeListView');
    var AttributeTotalsView = require('plugin/paid-attributes/view/step/AttributeTotalsView');
    var SidebarView = require('view/controller/booking/datetime/SidebarView');
	
	return BaseStep.extend({
		
		_step: 'paid_attributes',
		_skipStep: false,
        
        _shouldUpdateBookingModel: false,
        _isStepViewed: false,
        
        /**
		 * Inits instance, collection, subscribe to events
		 */
		initialize: function() {
	        BaseStep.prototype.initialize.call(this);
            
            this._stepManager.showStep('paid_attributes');
	        
	        this._paidAttributeCollection = this.getOption('collection');

	        this.listenTo(this._bookingModel, 'change:products', this.updateInfo);
	        this.listenTo(this._paidAttributeCollection, 'sync', this.onDataFetch);
	    },
        
        initStep: function () {
            if (this._bookingModel.get('addons') != this._bookingModel.getAddons()) {
                this._shouldUpdateBookingModel = true;
            }
        },
        
        /**
		 * Calls when collection fetched from server
		 */
		onDataFetch: function () {
			this.triggerStepEvent('fetch');
			this.updateInfo();

            if (this._paidAttributeCollection.length < 1 && this._bookingModel.get('service_id')) {
                this.setIsSkipped(true);
			} else {
                this.setIsSkipped(false);
			}
            
            if (this._shouldUpdateBookingModel) {
                var addons = this._bookingModel.get('addons');
                if (addons) addons = addons.split(',');
                
                var collection = this._paidAttributeCollection;
                _.each(addons, function (id) {
                    var productModel = collection.get(id);
                    if (productModel) {
                        productModel.set('qty', 1); 
                    }
                });
            }

			this.done();
		},
        
        /**
	     * Returns step view
	     * 
	     * @return AttributeLayout
	     */
		getView: function () {
            this._isStepViewed = true;
            var layout = new AttributeLayout({
                paidAttributeCollection: this._paidAttributeCollection
            });
            
            this.listenTo(layout, 'show', this._showRegions);
            this.listenTo(layout, 'go:next', this._onGoNext);

            return layout;
		},
        
        _onGoNext: function () {
            var urlBuilder = this.getOption('stepManager').getUrlBuilder();
            Backbone.history.navigate(urlBuilder.buildUrl(this.getOption('stepManager').getRouteName(), {
                addons: this._bookingModel.getAddons() || 'no'
            }), {'trigger': true});
        },
        
        /**
         * @todo why this works in such a strange way?
         * @return Boolean
         */
        isValid: function () {
            if (this.isStepSkipped()) return true;
            
            //TODO some condition to check when all necessary addons are selected and "next" clicked?
            if (this._bookingModel.get('addons') && this._isStepViewed) return true;
            
            return false;
        },

        isStepSkipped: function () {
            var isSkipped = BaseStep.prototype.isStepSkipped.call(this);
            //console.trace(isSkipped);
            return isSkipped;
        },
        
        /**
         * Returns sidebar booking info view
         *
         * @protected
         * @return SidebarView
         */
        _getSideBarView: function () {
            return new SidebarView({
                model: this._bookingModel
            });
        },
        
        /**
         * When layout appears add date and time view to layout regions
         * 
         * @param DateTimeStepDefaultLayout layout
         */
        _showRegions: function (layout) {
            if (layout.supportsSidebar()) {
                layout.getSideBarRegion().show(this._getSideBarView());
            }
            
            var view = new AttributeListView({
	    		bookingModel: this._bookingModel,
	    		collection: this._paidAttributeCollection
	    	});
            layout.getContentRegion().show(view);

            layout.getTotalsRegion().show(new AttributeTotalsView({
                bookingModel: this._bookingModel,
            }));
        },
        
    });
    
});

